import { useLocalObservable } from 'mobx-react-lite';

import Entities from 'STORE';

interface IUnreadBadgePresenter {
  hasNewMessages: boolean;
}

export function useUnreadBadgePresenter(): IUnreadBadgePresenter {
  return useLocalObservable<IUnreadBadgePresenter>(() => ({
    get hasNewMessages(): boolean {
      return Entities.GroupsStore.hasNewMessagesWithoutMute;
    },
  }));
}
